(function () {
  'use strict';

  var sbbNamespace = window.__SBB__ = window.__SBB__ || {};
  var ScaleBarBuilder = sbbNamespace.ScaleBarBuilder;
  var clamp = sbbNamespace.clamp;
  var parseNumber = sbbNamespace.parseNumber;
  var MAX_TAG_ID = sbbNamespace.maxTagId;
  var APRILTAG_BY_VALUE = sbbNamespace.aprilTagByValue;
  var APRILTAG_REFERENCE_FAMILIES = sbbNamespace.aprilTagReferenceFamilies;
  var REALITYSCAN_CODEBOOKS = sbbNamespace.realityScanCodebooks;
  var CIRCULAR_LIBRARY_META = sbbNamespace.circularLibraryMeta;
  var hashString = sbbNamespace.hashString;
  var nextRand = sbbNamespace.nextRand;
  if (!ScaleBarBuilder || !clamp || !parseNumber || !APRILTAG_BY_VALUE || !APRILTAG_REFERENCE_FAMILIES || !REALITYSCAN_CODEBOOKS || !hashString || !nextRand) {
    return;
  }

  ScaleBarBuilder.prototype.getRealityScanAprilTagCodebook = function (familyValue) {
    var familyKey = String(familyValue || this.state.tagFamily || '');
    if (!REALITYSCAN_CODEBOOKS || !REALITYSCAN_CODEBOOKS.apriltag) {
      return null;
    }
    var codebook = REALITYSCAN_CODEBOOKS.apriltag[familyKey];
    if (!codebook || !codebook.codeIndexByLabelId) {
      return null;
    }
    return codebook;
  };

  ScaleBarBuilder.prototype.isRealityScanAprilTagParityActive = function (familyValue) {
    if (this.state.softwarePreset !== 'realitycapture') {
      return false;
    }
    return !!this.getRealityScanAprilTagCodebook(familyValue || this.state.tagFamily);
  };

  ScaleBarBuilder.prototype.resolveAprilTagCodeIndex = function (tagId, familyValue) {
    var fallback = Math.max(0, Math.round(parseNumber(tagId, 0)));
    if (!this.isRealityScanAprilTagParityActive(familyValue || this.state.tagFamily)) {
      return fallback;
    }
    var codebook = this.getRealityScanAprilTagCodebook(familyValue || this.state.tagFamily);
    if (!codebook || !codebook.codeIndexByLabelId) {
      return fallback;
    }
    var mapped = codebook.codeIndexByLabelId[String(fallback)];
    var parsed = Math.round(parseNumber(mapped, NaN));
    if (Number.isFinite(parsed)) {
      return Math.max(0, parsed);
    }

    if (Array.isArray(codebook.validLabelIds) && codebook.validLabelIds.length) {
      var firstValid = Math.max(0, Math.round(parseNumber(codebook.validLabelIds[0], fallback)));
      var mappedFirst = codebook.codeIndexByLabelId[String(firstValid)];
      var parsedFirst = Math.round(parseNumber(mappedFirst, NaN));
      if (Number.isFinite(parsedFirst)) {
        return Math.max(0, parsedFirst);
      }
    }

    return fallback;
  };

  ScaleBarBuilder.prototype.getRealityScanCircularCodebook = function (familyValue) {
    var familyKey = String(familyValue || this.state.tagFamily || '');
    if (!REALITYSCAN_CODEBOOKS || !REALITYSCAN_CODEBOOKS.circular) {
      return null;
    }
    var codebook = REALITYSCAN_CODEBOOKS.circular[familyKey];
    if (!codebook || !codebook.codeByLabelId) {
      return null;
    }
    return codebook;
  };

  ScaleBarBuilder.prototype.resolveRealityScanCircularCode = function (tagId, familyValue) {
    var codebook = this.getRealityScanCircularCodebook(familyValue || this.state.tagFamily);
    if (!codebook) {
      return null;
    }

    var rawId = Math.max(0, Math.round(parseNumber(tagId, 0)));
    var code = codebook.codeByLabelId[String(rawId)];
    var resolvedId = rawId;

    if (!code) {
      var validIds = Array.isArray(codebook.validLabelIds) ? codebook.validLabelIds : [];
      if (!validIds.length) {
        return null;
      }
      var normalizedValid = [];
      for (var vi = 0; vi < validIds.length; vi += 1) {
        normalizedValid.push(Math.max(0, Math.round(parseNumber(validIds[vi], 0))));
      }
      normalizedValid.sort(function (a, b) { return a - b; });
      var idx = 0;
      while (idx < normalizedValid.length && normalizedValid[idx] < rawId) {
        idx += 1;
      }
      if (idx >= normalizedValid.length) {
        idx = 0;
      }
      resolvedId = normalizedValid[idx];
      code = codebook.codeByLabelId[String(resolvedId)] || '';
    }

    if (!code) {
      return null;
    }

    return {
      labelId: resolvedId,
      code: String(code),
      segments: Math.max(1, Math.round(parseNumber(codebook.segments, 0))),
      ringMode: codebook.ringMode === 'dual' ? 'dual' : 'single'
    };
  };

  ScaleBarBuilder.prototype.getOfficialAprilTagFamily = function (familyValue) {
    var familyKey = String(familyValue || '');
    if (!familyKey || !APRILTAG_REFERENCE_FAMILIES[familyKey]) {
      return null;
    }
    if (!this.aprilFamilyCodeCache) {
      this.aprilFamilyCodeCache = {};
    }
    if (this.aprilFamilyCodeCache[familyKey]) {
      return this.aprilFamilyCodeCache[familyKey];
    }

    var raw = APRILTAG_REFERENCE_FAMILIES[familyKey];
    var codes = [];
    if (raw.codesHex && typeof raw.codesHex === 'string') {
      codes = raw.codesHex.split(',');
    }
    var family = {
      nbits: Math.max(0, Math.round(parseNumber(raw.nbits, 0))),
      ncodes: Math.max(0, Math.round(parseNumber(raw.ncodes, codes.length))),
      widthAtBorder: Math.max(1, Math.round(parseNumber(raw.widthAtBorder, 1))),
      totalWidth: Math.max(1, Math.round(parseNumber(raw.totalWidth, 1))),
      reversedBorder: !!raw.reversedBorder,
      bitX: Array.isArray(raw.bitX) ? raw.bitX.slice() : [],
      bitY: Array.isArray(raw.bitY) ? raw.bitY.slice() : [],
      codes: codes
    };
    this.aprilFamilyCodeCache[familyKey] = family;
    return family;
  };

  ScaleBarBuilder.prototype.getAprilTagFamilyCodeCount = function (familyValue) {
    var familyKey = familyValue || this.state.tagFamily;
    if (this.isRealityScanAprilTagParityActive(familyKey)) {
      var rsCodebook = this.getRealityScanAprilTagCodebook(familyKey);
      if (rsCodebook && Array.isArray(rsCodebook.validLabelIds)) {
        return rsCodebook.validLabelIds.length;
      }
    }
    var family = this.getOfficialAprilTagFamily(familyValue || this.state.tagFamily);
    return family && Array.isArray(family.codes) ? family.codes.length : 0;
  };

  ScaleBarBuilder.prototype.getAprilTagIdUpperBound = function (familyValue) {
    var familyKey = familyValue || this.state.tagFamily;
    if (this.isRealityScanAprilTagParityActive(familyKey)) {
      var rsCodebook = this.getRealityScanAprilTagCodebook(familyKey);
      if (rsCodebook && Array.isArray(rsCodebook.validLabelIds) && rsCodebook.validLabelIds.length) {
        var maxLabel = 0;
        for (var i = 0; i < rsCodebook.validLabelIds.length; i += 1) {
          maxLabel = Math.max(maxLabel, Math.round(parseNumber(rsCodebook.validLabelIds[i], 0)));
        }
        return maxLabel;
      }
    }
    var count = this.getAprilTagFamilyCodeCount(familyValue || this.state.tagFamily);
    return count > 0 ? count - 1 : MAX_TAG_ID;
  };

  ScaleBarBuilder.prototype.getAprilTagIdLowerBound = function (familyValue) {
    var familyKey = familyValue || this.state.tagFamily;
    if (this.isRealityScanAprilTagParityActive(familyKey)) {
      var rsCodebook = this.getRealityScanAprilTagCodebook(familyKey);
      if (rsCodebook && Array.isArray(rsCodebook.validLabelIds) && rsCodebook.validLabelIds.length) {
        var minLabel = Math.max(0, Math.round(parseNumber(rsCodebook.validLabelIds[0], 0)));
        for (var i = 1; i < rsCodebook.validLabelIds.length; i += 1) {
          minLabel = Math.min(minLabel, Math.max(0, Math.round(parseNumber(rsCodebook.validLabelIds[i], 0))));
        }
        return minLabel;
      }
    }
    return 0;
  };

  ScaleBarBuilder.prototype.getCircularLibraryMeta = function () {
    if (typeof CIRCULAR_LIBRARY_META !== 'undefined' && CIRCULAR_LIBRARY_META && typeof CIRCULAR_LIBRARY_META === 'object') {
      return CIRCULAR_LIBRARY_META;
    }
    if (typeof window !== 'undefined' && window.SBB_CIRCULAR_LIBRARY_META && typeof window.SBB_CIRCULAR_LIBRARY_META === 'object') {
      return window.SBB_CIRCULAR_LIBRARY_META;
    }
    return {};
  };

  ScaleBarBuilder.prototype.getCircularTagIdBounds = function (familyValue) {
    var codebook = this.getRealityScanCircularCodebook(familyValue || this.state.tagFamily);
    if (!codebook || !Array.isArray(codebook.validLabelIds) || !codebook.validLabelIds.length) {
      var circularMetaMap = this.getCircularLibraryMeta();
      var familyMeta = circularMetaMap[String(familyValue || this.state.tagFamily || '')];
      var familyCount = familyMeta ? Math.max(0, Math.round(parseNumber(familyMeta.count, 0))) : 0;
      if (familyCount > 0) {
        return { min: 0, max: Math.max(0, familyCount - 1) };
      }
      return { min: 0, max: MAX_TAG_ID };
    }
    var minLabel = Math.max(0, Math.round(parseNumber(codebook.validLabelIds[0], 0)));
    var maxLabel = minLabel;
    for (var i = 1; i < codebook.validLabelIds.length; i += 1) {
      var value = Math.max(0, Math.round(parseNumber(codebook.validLabelIds[i], minLabel)));
      minLabel = Math.min(minLabel, value);
      maxLabel = Math.max(maxLabel, value);
    }
    return { min: minLabel, max: maxLabel };
  };

  ScaleBarBuilder.prototype.getValidTagIdList = function (tagType, familyValue) {
    var type = String(tagType || this.state.tagType || 'apriltag');
    var family = String(familyValue || this.state.tagFamily || '');
    var centerFiltered = this.state.filterAprilTagCenters !== false;
    var cacheKey = type + '|' + family + '|' + (centerFiltered ? 'center' : 'all');
    var cached = this.validTagIdListCache[cacheKey];
    if (Array.isArray(cached) && cached.length) {
      return cached;
    }

    var ids = [];
    var seen = {};
    var addId = function (raw) {
      var id = Math.max(0, Math.round(parseNumber(raw, 0)));
      if (seen[id]) {
        return;
      }
      seen[id] = true;
      ids.push(id);
    };

    if (type === 'apriltag') {
      if (this.isRealityScanAprilTagParityActive(family)) {
        var apriltagCodebook = this.getRealityScanAprilTagCodebook(family);
        var labelIds = apriltagCodebook && Array.isArray(apriltagCodebook.validLabelIds) ? apriltagCodebook.validLabelIds : [];
        for (var ai = 0; ai < labelIds.length; ai += 1) {
          addId(labelIds[ai]);
        }
      } else {
        var aprilCount = this.getAprilTagFamilyCodeCount(family);
        for (var aj = 0; aj < aprilCount; aj += 1) {
          addId(aj);
        }
      }
      ids.sort(function (a, b) { return a - b; });
      if (centerFiltered) {
        var self = this;
        ids = ids.filter(function (id) {
          return self.isAprilTagCenterPatternValid(id);
        });
      }
    } else if (type === 'circular') {
      var circularBounds = this.getCircularTagIdBounds(family);
      for (var ci = circularBounds.min; ci <= circularBounds.max; ci += 1) {
        addId(ci);
      }
      ids.sort(function (a, b) { return a - b; });
    }

    if (!ids.length) {
      ids = [0];
    }
    this.validTagIdListCache[cacheKey] = ids;
    return ids;
  };

  ScaleBarBuilder.prototype.getCurrentTagIdBounds = function (tagType, familyValue) {
    var type = tagType || this.state.tagType;
    var family = familyValue || this.state.tagFamily;
    if (type === 'apriltag') {
      var aprilMin = this.getAprilTagIdLowerBound(family);
      var aprilMax = this.getAprilTagIdUpperBound(family);
      return { min: aprilMin, max: Math.max(aprilMin, aprilMax) };
    }
    if (type === 'circular') {
      var circularBounds = this.getCircularTagIdBounds(family);
      return { min: circularBounds.min, max: Math.max(circularBounds.min, circularBounds.max) };
    }
    return { min: 0, max: MAX_TAG_ID };
  };

  ScaleBarBuilder.prototype.getAprilTagBitFromHexCode = function (hexCode, bitIndexFromLsb) {
    if (!hexCode || bitIndexFromLsb < 0) {
      return 0;
    }
    var nibbleIndex = Math.floor(bitIndexFromLsb / 4);
    var charIndex = hexCode.length - 1 - nibbleIndex;
    if (charIndex < 0 || charIndex >= hexCode.length) {
      return 0;
    }
    var nibble = parseInt(hexCode.charAt(charIndex), 16);
    if (!Number.isFinite(nibble)) {
      return 0;
    }
    return (nibble >> (bitIndexFromLsb % 4)) & 1;
  };

  ScaleBarBuilder.prototype.buildFallbackAprilTagMatrix = function (tagId) {
    var familyConfig = APRILTAG_BY_VALUE[this.state.tagFamily] || { modules: 6 };
    var modules = familyConfig.modules;
    var seed = { value: hashString(this.state.tagFamily + ':' + tagId) };
    var total = modules + 2;
    var matrix = [];
    var row;
    var col;

    for (row = 0; row < total; row += 1) {
      var rowValues = [];
      for (col = 0; col < total; col += 1) {
        rowValues.push(true);
      }
      matrix.push(rowValues);
    }
    for (row = 1; row < total - 1; row += 1) {
      for (col = 1; col < total - 1; col += 1) {
        matrix[row][col] = false;
      }
    }
    for (row = 0; row < modules; row += 1) {
      for (col = 0; col < modules; col += 1) {
        matrix[row + 1][col + 1] = nextRand(seed) > 0.5;
      }
    }
    return matrix;
  };

  ScaleBarBuilder.prototype.buildOfficialAprilTagMatrix = function (family, tagId) {
    if (!family || !family.codes || !family.codes.length || family.nbits <= 0 || family.totalWidth <= 0) {
      return null;
    }

    var parityActive = this.isRealityScanAprilTagParityActive(this.state.tagFamily);
    var codeIndex = clamp(this.resolveAprilTagCodeIndex(tagId, this.state.tagFamily), 0, family.codes.length - 1);
    var codeHex = String(family.codes[codeIndex] || '');
    if (!codeHex) {
      return null;
    }

    var totalWidth = parityActive ? family.widthAtBorder : family.totalWidth;
    var widthAtBorder = family.widthAtBorder;
    var borderStart = parityActive ? 0 : Math.floor((totalWidth - widthAtBorder) / 2);
    var defaultBlack = !!family.reversedBorder;
    var borderBlack = !family.reversedBorder;
    var matrix = [];
    var row;
    var col;

    for (row = 0; row < totalWidth; row += 1) {
      var rowValues = [];
      for (col = 0; col < totalWidth; col += 1) {
        rowValues.push(defaultBlack);
      }
      matrix.push(rowValues);
    }

    for (row = borderStart; row < borderStart + widthAtBorder; row += 1) {
      for (col = borderStart; col < borderStart + widthAtBorder; col += 1) {
        if (row >= 0 && row < totalWidth && col >= 0 && col < totalWidth) {
          matrix[row][col] = borderBlack;
        }
      }
    }

    for (var i = 0; i < family.nbits; i += 1) {
      var bx = borderStart + Math.round(parseNumber(family.bitX[i], 0));
      var by = borderStart + Math.round(parseNumber(family.bitY[i], 0));
      if (bx < 0 || bx >= totalWidth || by < 0 || by >= totalWidth) {
        continue;
      }
      var bit = this.getAprilTagBitFromHexCode(codeHex, family.nbits - 1 - i);
      matrix[by][bx] = bit === 0;
    }
    return matrix;
  };

  ScaleBarBuilder.prototype.getGeneratedAprilTagMatrix = function (tagId) {
    var family = this.getOfficialAprilTagFamily(this.state.tagFamily);
    var bounds = this.getCurrentTagIdBounds('apriltag', this.state.tagFamily);
    var normalizedId = clamp(Math.round(parseNumber(tagId, bounds.min)), bounds.min, bounds.max);
    var parityActive = this.isRealityScanAprilTagParityActive(this.state.tagFamily);
    var resolvedCodeIndex = this.resolveAprilTagCodeIndex(normalizedId, this.state.tagFamily);
    var key = this.state.tagFamily + ':' + (parityActive ? 'rs' : 'std') + ':' + normalizedId + ':' + resolvedCodeIndex;
    var cached = this.aprilMatrixCache.get(key);
    if (cached) {
      return cached;
    }

    var matrix = this.buildOfficialAprilTagMatrix(family, normalizedId);
    if (!matrix) {
      matrix = this.buildFallbackAprilTagMatrix(normalizedId);
    }

    this.aprilMatrixCache.set(key, matrix);
    return matrix;
  };

  ScaleBarBuilder.prototype.isAprilTagCenterPatternValid = function (tagId) {
    var matrix = this.getGeneratedAprilTagMatrix(tagId);
    if (!matrix || matrix.length < 2) {
      return false;
    }

    var modules = matrix.length;
    var start = Math.floor(modules / 2) - 1;
    start = clamp(start, 0, modules - 2);

    var tl = matrix[start][start];
    var tr = matrix[start][start + 1];
    var bl = matrix[start + 1][start];
    var br = matrix[start + 1][start + 1];

    var triadPattern = tl === tr && ((bl === tl && br !== tl) || (br === tl && bl !== tl));
    var checkerPattern = tl === br && tr === bl && tl !== tr;

    return triadPattern || checkerPattern;
  };

  ScaleBarBuilder.prototype.isTagIdViable = function (tagId) {
    var validIds = this.getValidTagIdList(this.state.tagType, this.state.tagFamily);
    if (!Array.isArray(validIds) || !validIds.length) {
      return false;
    }
    var candidate = Math.round(parseNumber(tagId, validIds[0]));
    for (var i = 0; i < validIds.length; i += 1) {
      if (validIds[i] === candidate) {
        return true;
      }
    }
    return false;
  };

  ScaleBarBuilder.prototype.findNextUniqueViableTagId = function (tagId, usedIds, reservedIds) {
    var validIds = this.getValidTagIdList(this.state.tagType, this.state.tagFamily);
    if (!Array.isArray(validIds) || !validIds.length) {
      return 0;
    }
    var bounded = Math.round(parseNumber(tagId, validIds[0]));
    var startIndex = 0;
    while (startIndex < validIds.length && validIds[startIndex] < bounded) {
      startIndex += 1;
    }
    if (startIndex >= validIds.length) {
      startIndex = 0;
    }
    for (var delta = 0; delta < validIds.length; delta += 1) {
      var candidate = validIds[(startIndex + delta) % validIds.length];
      if (usedIds[candidate]) {
        continue;
      }
      if (reservedIds && reservedIds[candidate]) {
        continue;
      }
      return candidate;
    }
    return validIds[startIndex];
  };

  ScaleBarBuilder.prototype.findPrevUniqueViableTagId = function (tagId, usedIds, reservedIds) {
    var validIds = this.getValidTagIdList(this.state.tagType, this.state.tagFamily);
    if (!Array.isArray(validIds) || !validIds.length) {
      return 0;
    }
    var bounded = Math.round(parseNumber(tagId, validIds[validIds.length - 1]));
    var startIndex = validIds.length - 1;
    while (startIndex >= 0 && validIds[startIndex] >= bounded) {
      startIndex -= 1;
    }
    if (startIndex < 0) {
      startIndex = validIds.length - 1;
    }
    for (var delta = 0; delta < validIds.length; delta += 1) {
      var candidate = validIds[(startIndex - delta + validIds.length) % validIds.length];
      if (usedIds[candidate]) {
        continue;
      }
      if (reservedIds && reservedIds[candidate]) {
        continue;
      }
      return candidate;
    }
    return validIds[startIndex];
  };
})();
